'use strict';

var util = require('../util'),
	sizeChart = require('../sizechart'),
    dialog = require('../dialog'),
    progress = require('../progress');

/**
 * @function initializeContactUs
 * @description Initializes the events associated to the contactUs page
 */
function initializeContactUs() {
        
    // Initialize the customer-service selectors
    var $categorySelect = $('#dwfrm_contactus_category');
    var $subCategorySelect = $('#dwfrm_contactus_subcategory');
    
    // Initialize the master category-list
    var categories = getCategories();
    
    // As part of initialization, build out the topic-object
    createCSTTopicObject();
    
    // Seed the sub-category form-field options
    seedOptions($categorySelect, categories, false, true);
    seedListItems($categorySelect, categories);
    
    // Was a selected category included in the display?
    if (window.cs.hasOwnProperty('selectedCategory')) {
        
        // If so, then show the category as selected
        selectOption($categorySelect, window.cs.selectedCategory);
        
        // Seed the options for the specified sub-category
        seedSubCategories($categorySelect, $subCategorySelect);
        
        // Once rendered, select the specified sub-category value
        selectOption($subCategorySelect, window.cs.selectedSubCategory);
                
    }
        
    // Listen for any changes to the category select-field
    $categorySelect.on('change', function() {
        
        // For a change, seed the sub-categories
        seedSubCategories($(this), $subCategorySelect);
                
    });
            
}

/**
 * @private
 * @function seedSubCategories
 * @param {Element} $categorySelect The jQuery object representing the category selector
 * @param {Element} $subCategorySelect The jQuery object representing the sub-category selector 
 * @description	A helper function to seed the sub-categories for a selected option
 */
function seedSubCategories($categorySelect, $subCategorySelect) {
    
    // Initialize local variables
    var selectedOption, optionsArray, rootCategory;
    
    // Get the current selection
    selectedOption = $categorySelect.find(':selected').text();
    
    // Retrieve the sub-categories for the selected option
    optionsArray = getSubCategories(selectedOption);
    
    // Determine if the current category is the root category
    rootCategory = isRootCategory(selectedOption);
    
    // Seed the sub-category form-field options
    seedOptions($subCategorySelect, optionsArray, true, rootCategory);
    seedListItems($subCategorySelect, optionsArray, true);
        
}

/**
 * @private
 * @function seedOptions
 * @description Seed the options for a given select select field options 
 * @param {Element} $select The jQuery object representing the sub-category select-field
 * @param {Array} optionsArray The array containing the list of options to render
 * @param {Boolean} isSubCategory Flag to specify that the options being rendered are for a sub-cat
 * @param {Boolean} isRootCategory Flag to specify that this is / is not the root category
 */
function seedOptions($select, optionsArray, isSubCategory, isRootCategory) {
    
    // Initialize local variables
    var $option, optionLabel, defaultMessage, renderOptionValue;
        
    // Let's remove the options attached to the sub-category field
    $select.find('OPTION').remove();

    // Are we rendering category or sub-category options?  If it's a sub-category,
    // then let's include the default sub-category message in all option displays
    if (isSubCategory) {

        // Capture the default sub-category display message
        defaultMessage = getDefaultMessage();	
        
        // Build out a new option for the customer-service topics display
        $option = createSelectOption(defaultMessage, '', false);
        
        // Append the default option to the sub-category select
        $select.append($option);
            
    }
    
    // Loop over the collection of sub-categories and seed the sub-cat options
    for (var arrayIndex = 0; arrayIndex < optionsArray.length; arrayIndex ++) {
        
        // Create a reference to the sub-category label
        optionLabel = optionsArray[arrayIndex];

        // Are we rendering category values?  If so, don't render the value of the first option
        if (isRootCategory && arrayIndex === 0) {
            renderOptionValue = false;
        } else {
            renderOptionValue = true;
        }
                
        // Build out an option-instance of the sub-category label
        $option = createSelectOption(optionLabel, optionLabel, renderOptionValue);

        // Append each category-specific sub-category
        $select.append($option);
        
    }
    
    // Update the select-list that was just updated
    util.updateselect();
    
}

/**
 * @private
 * @function seedListItems
 * @description Seed the specified unordered-list field list-items with new option / values
 * @param {Element} $select The jQuery object representing the select field to process
 * @param {Array} optionsArray The array containing the list of option-values to render
 * @param {Boolean} isSubCategory Flag to specify that the options being rendered are for a sub-cat
 */
function seedListItems($select, optionsArray, isSubCategory) {
    
    // Initialize local variables
    var $ul, $li, optionLabel, defaultMessage;
        
    // Find the sub-category select list to work with
    $ul = $select.parent().find('ul.selection-list');
    
    // Let's remove the list-items attached to the sub-category list
    $ul.find('li').remove();

    // Capture the default sub-category display message
    defaultMessage = getDefaultMessage();

    // Is this a sub-category being rendered?
    if (isSubCategory === true) {

        // Build out a new list-item for the customer-service topics display
        $li = createListItem(defaultMessage, true);

        // Append the default list-item to the sub-category select
        $ul.append($li);

    }

    // Loop over the collection of sub-categories and seed the sub-cat options
    for (var subCatIndex = 0; subCatIndex < optionsArray.length; subCatIndex ++) {
        
        // Create a reference to the sub-category label
        optionLabel = optionsArray[subCatIndex];

        // Only render the optionLabel if this is not the defaultMessage
        if (optionLabel !== defaultMessage) {

            // Build out an option-instance of the sub-category label
            $li = createListItem(optionLabel, false);

            // Append each category-specific sub-category
            $ul.append($li);

        }

    }		
    
}

/**
 * @private
 * @function selectOption
 * @description For a given select-field, present the specified option as selected / chosen
 * @param {Element} $select The jQuery object representing the select field to process
 * @param {String} optionValue The property selected by the user
 */
function selectOption($select, optionValue) {
    
    // First, show the option value as selected
    $select.val(optionValue);
    
    // Second, launch the utility-method to update the select-box treatment
    util.updateselect();
    
}

/**
 * @private
 * @function createCSTTopicObject
 * @description Helper function to convert the topics array to an object (makes lookups easier)
 */
function createCSTTopicObject() {
    
    // Initialize local variables
    var thisTopic, thisCategory;
    
    // Initialize the topics object
    window.cs.cstTopicsObject = {};
    
    // Loop over the collection of topics
    for (var arrayIndex=0; arrayIndex < window.cs.cstTopics.length; arrayIndex ++) {
    
        // Create a reference to the current topic
        thisTopic = window.cs.cstTopics[arrayIndex];
        
        // Pull out the category
        thisCategory = thisTopic.reasonCategory;
        
        // Set the category as the key, and directly map its sub-categories
        window.cs.cstTopicsObject[thisCategory] = thisTopic.reasons;
        
    }

}

/**
 * @private
 * @function getDefaultMessage
 * @description Helper function to return the default sub-category message
 */
function getDefaultMessage() {
    
    // Return the default sub-category message
    return window.cs.cstTopics[0].reasons[0];

}

/**
 * @private
 * @function getCategories
 * @description Helper function to return the collection of customer-service categories
 */
function getCategories() {
    
    // Initialize local variables
    var thisTopic, thisCategory, categories;
    
    // Check if the category-array has already been cached
    if (window.cs.hasOwnProperty('cstCategories')) {
        return window.cs.cstCategories;
    }
    
    // Default the categories array
    categories = [];
    
    // Loop over the collection of topics
    for (var arrayIndex=0; arrayIndex < window.cs.cstTopics.length; arrayIndex ++) {
    
        // Create a reference to the current topic
        thisTopic = window.cs.cstTopics[arrayIndex];
        
        // Pull out the category and collect it
        thisCategory = thisTopic.reasonCategory;		
        categories.push(thisCategory);
        
    }	
    
    // Cache the categories array in the cs name-space
    window.cs.cstCategories = categories;
    
    // Return the collection of categories
    return categories

}

/**
 * @private
 * @function getSubCategories
 * @description Helper function to return the sub-categories for a given category
 */
function getSubCategories(categoryName) {
    
    // Return the collection of sub-categories associated to this category
    return window.cs.cstTopicsObject[categoryName];

}

/**
 * @private
 * @function getSubCategories
 * @param {String} categoryName Describes the current / selected category
 * @description Helper function to identify if the selected category is the root category
 */
function isRootCategory(categoryName) {
    
    // Initialize local variables
    var cstCategories = getCategories();
    
    // Check if the current category is the root / default category
    if (categoryName === cstCategories[0]) {
        return true;
    } else {
        return false;
    }
    
}

/**
 * @private
 * @function	createSelectOption
 * @description Factory to create the option element containing option / value information
 * @param {String} optionLabel The string representing the label to render for a given option
 * @param {String} optionValue The string representing the value to render for a given option
 * @param {Boolean} renderOptionValue Flag that denotes whether the optionValue should be rendered
 */
function createSelectOption(optionLabel, optionValue, renderOptionValue) {

    // Initialize local variables
    var newOption, $option;
    
    // Create a new option and jQuery it
    newOption = $('<option>');
    $option = $(newOption);
    
    // Set the label and add the expected class
    $option.text(optionLabel);
    $option.addClass('select-option');

    // Render the option value (or don't)
    if (renderOptionValue) {
        $option.val(optionValue);		
    } else {
        $option.val(null);
    }
    
    // Return the customized option
    return $option;
            
}

/**
 * @private
 * @function	createListItem
 * @description Factory to create the list-item element containing option / value information
 * @param {String} optionLabel The string representing the label to render for a given option
 * @param {Boolean} selected Denotes whether a given option should be flagged as selected in the list-item
 */
function createListItem(optionLabel, selected) {
    
    // Initialize local variables
    var newLi, $li;
        
    // Create a new list-item and jQuery it
    newLi = $('<li>');
    $li = $(newLi);
    
    // Set the label and text value
    $li.attr('label', optionLabel);
    $li.html(optionLabel);

    // Add the selected class if this is 
    if (selected === true) {
        $li.addClass('selected');
    }
    
    // Return the customized option
    return $li;
            
}

$('.secondary-article-heading').on('click', function() {
    var $curobj = $('.secondary-article-heading');
    var $curparent = $curobj.closest('.secondary-aticle-content');
    var $expanded = $('.secondary-left-section');
    $curobj.toggleClass('active');
    $curparent.toggleClass('active');
    $expanded.toggleClass('active');
});

var $expanded = $('.secondary-left-section');
var $curvalue = $expanded.find('.currentpage').text();
var $url = $expanded.find('.currentpage').attr("href");
if (window.location.href.split(window.location.host)[1] == $url) {
	$('.secondary-article-heading.mobile-nav').text($curvalue);
}


$('#ContactUsForm').submit(function() {
    $(this).validate();
    if ($(this).valid()) {
        progress.show($('.contact-us-page'));
        $("#contactUsSubmit").attr('disabled', true);
        setTimeout(function(){ 
            progress.hide();
            $("#contactUsSubmit").attr('disabled', false);
         }, 5000);
    }
    return true;
});

sizeChart.init();
sizeChart.populateSizeGuideJSMenu();
sizeChart.eventsSizeGuideJSMenu();

exports.init = function() {
    
    // Has the customerService namespace been defined?
    if (window.hasOwnProperty('cs')) {
        
        // Is the page-type defined in the cs namespace?
        if (window.cs.hasOwnProperty('pageType')) {
            
            // Iterate over the configured page-types
            switch (window.cs.pageType) {
            
                case 'contact-us':
                    
                    // Initialize the contactUs display
                    initializeContactUs();
                    
                    break;
                                
            }
                        
        }
                
    }
        
}